import {Model} from '@vuex-orm/core';

export class StudentBlacklistDocument extends Model {
  static entity = 'student_blacklist-documents';

  static primaryKey = ['studentId', 'documentId'];

  static fields() {
    return {
      studentId: this.attr(null),
      documentId: this.attr(null),
    };
  }

  studentId: string;
  documentId: string;
}
